// components/ErrorBoundary.jsx
import React from 'react';
import { toast } from 'react-hot-toast';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error:', error, info);
    toast.error("Ocurrió un error inesperado. Por favor, intenta de nuevo.");
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="p-4 text-center">
          <p className="text-sm text-gray-700 mb-2">
            Ocurrió un error inesperado. Por favor, intenta de nuevo.
          </p>
          {this.state.error?.message && (
            <p className="text-xs text-gray-500 mb-3" aria-live="polite">
              {this.state.error.message}
            </p>
          )}
          <button
            type="button"
            onClick={this.handleRetry}
            className="px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:opacity-90 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;